webpackJsonp([175520541904455],{

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	    var caseStudies = _ref.caseStudies;
	    return _react2.default.createElement(
	        'div',
	        null,
	        caseStudies.map(function (caseStudy, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: "case-study-" + index },
	                _react2.default.createElement(
	                    'section',
	                    { id: caseStudy.node.frontmatter.path, className: 'hero is-sjs-dark-blue' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'hero-body' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'container' },
	                            _react2.default.createElement(
	                                'h2',
	                                { className: 'title' },
	                                'Case Study: ',
	                                caseStudy.node.frontmatter.title
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { className: 'section' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'container content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'columns' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'column is-10 is-offset-1' },
	                                _react2.default.createElement(_Content.HTMLContent, { content: caseStudy.node.html })
	                            )
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PageQuery = exports.CaseStudiesPageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _graphql = __webpack_require__(11);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(17);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(8);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _Team = __webpack_require__(16);
	
	var _Team2 = _interopRequireDefault(_Team);
	
	var _ResourceList = __webpack_require__(18);
	
	var _ResourceList2 = _interopRequireDefault(_ResourceList);
	
	var _Contact = __webpack_require__(12);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	var _CaseStudiesSection = __webpack_require__(207);
	
	var _CaseStudiesSection2 = _interopRequireDefault(_CaseStudiesSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CaseStudiesPageTemplate = exports.CaseStudiesPageTemplate = function CaseStudiesPageTemplate(_ref) {
	  var title = _ref.title,
	      content = _ref.content,
	      caseStudies = _ref.caseStudies,
	      contentComponent = _ref.contentComponent;
	
	  var PageContent = contentComponent || _Content2.default;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'San Juan Software | Case Studies'
	    }),
	    _react2.default.createElement(_CaseStudiesSection2.default, { caseStudies: caseStudies }),
	    _react2.default.createElement(_Contact2.default, null)
	  );
	};
	
	exports.default = function (_ref2) {
	  var data = _ref2.data;
	  var _data$markdownRemark = data.markdownRemark,
	      frontmatter = _data$markdownRemark.frontmatter,
	      html = _data$markdownRemark.html;
	
	  var caseStudies = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(CaseStudiesPageTemplate, {
	    contentComponent: _Content.HTMLContent,
	    title: frontmatter.title,
	    content: html,
	    caseStudies: caseStudies
	  });
	};
	
	var PageQuery = exports.PageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-case-studies-page-js-3a135a88fed2c45ce5c8.js